import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=ba16c4bc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba16c4bc')) {
      api.createRecord('ba16c4bc', component.options)
    } else {
      api.reload('ba16c4bc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=ba16c4bc&", function () {
      api.rerender('ba16c4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dNFJDYnVtZHr/JS/pricehelp.vue"
export default component.exports